import {GET, POST} from "./api.js"; 

export const tutorials = {
    tutorialsConsult:() => GET(`/tutorials/info`),
}